// "Saved networks from: [ location ▾ ]" — the one control every add-Wi-Fi
// dialog carries, so an operator at the office can borrow a customer's saved
// Wi-Fi for a device still on the bench. See core/hooks/useLocationChoices for
// why this is a choice at all.
//
// An Autocomplete, not a Select: a Super Admin's list is a hundred-odd sites and
// "Home" appears dozens of times, so it has to be searchable and the option key
// has to be the id — see the note in ui/shared/userOption on what MUI does with
// repeated labels otherwise.

import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import useLocationChoices, { locationLabel } from '../../core/hooks/useLocationChoices';
import { tokenFilter } from '../../core/utils/search';

export default function LocationSelect({
  value, onChange, label = 'Saved networks from', size = 'small', sx, textSx,
}) {
  const { choices, loading } = useLocationChoices();
  const current = choices.find((l) => String(l.LocationID) === String(value)) || null;

  return (
    <Autocomplete
      size={size}
      sx={sx}
      options={choices}
      value={current}
      loading={loading}
      onChange={(_, l) => onChange(l ? l.LocationID : null)}
      getOptionLabel={locationLabel}
      isOptionEqualToValue={(a, b) => String(a.LocationID) === String(b.LocationID)}
      filterOptions={tokenFilter((l) => `${locationLabel(l)} ${l.LocationID}`)}
      renderOption={(props, l) => (
        <li {...props} key={String(l.LocationID)}>{locationLabel(l)}</li>
      )}
      renderInput={(p) => <TextField {...p} label={label} sx={textSx} />}
    />
  );
}
